module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "chapter",
      "id": "rch2",
      "title": "Chapter Two: Paleo Diet Basics"
    }
  }, [_c('p', {
    staticClass: "ch-number"
  }, [_c('b', [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_11",
      "title": "11"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Contents#ch2"
    }
  }, [_vm._v("CHAPTER TWO")])])])]), _vm._v(" "), _c('p', {
    staticClass: "ch-title"
  }, [_c('a', {
    attrs: {
      "href": "#/text/Contents#ch2"
    }
  }, [_c('b', [_vm._v("Paleo Diet Basics")])])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("The Paleo diet is based on the premise that the foods that humans ate for 99 percent of our evolutionary history—the time before the advent of agriculture—should comprise most, if not all, of our diet today. This includes things that could have been hunted or gathered: wild game and fish, roots, vegetables, seasonal fruit, eggs, nuts, and seeds. The Paleo diet confers numerous health benefits as well, which is not surprising since it eliminates the refined carbohydrates that dominate the Western diet. People who adopt a Paleo diet often observe weight loss, reduced food cravings, better sleep, elimination of allergies, improved skin clarity, better digestive function, and even remission of autoimmune disorders.")]), _vm._v(" "), _c('p', {
    staticClass: "ch-sub"
  }, [_c('b', [_vm._v("What to Eat")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("Modern interpretations of the hunter gatherer diet include pastured meats, wild fish and seafood, locally grown seasonal produce, nuts, seeds, fermented foods, and healthy fats, such as coconut and olive oils. These foods are loaded with the essential fats, amino acids, digestible carbohydrates, fiber, vitamins, minerals, antioxidants, and phytochemicals that have contributed to health and longevity for millennia.")]), _vm._v(" "), _c('p', {
    staticClass: "ch-sec"
  }, [_vm._v("Meat and Poultry")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("Meat and poultry form the caloric foundation of the Paleo diet. Wild game and organic, pastured meats are ideal. While none of the recipes in this book explicitly call for grass-fed, organic, free-range, or pastured meats, those are the best choices.")]), _vm._v(" "), _c('p', {
    staticClass: "normal-tbsa"
  }, [_vm._v("If that is not possible, choose meat that has not been fed animal byproducts or administered routine antibiotics or hormones. For nutrition and flavor, choose fatty cuts of meat, such as chicken thighs over chicken breasts. Better yet, buy the whole chicken and use the bones to make a nourishing bone broth. Organ meats are also a rich source of minerals and should occasionally grace your table. Here are the more common meat and poultry options in the Paleo diet:")]), _vm._v(" "), _c('p', {
    staticClass: "bulllist"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "src": "images/squ.jpg"
    }
  }), _c('span', {
    staticClass: "hide"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "4",
      "src": "images/squ.jpg",
      "width": "5"
    }
  })]), _c('span', {
    staticClass: "spacea"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Beef")])]), _vm._v(" "), _c('p', {
    staticClass: "bulllist"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "src": "images/squ.jpg"
    }
  }), _c('span', {
    staticClass: "hide"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "4",
      "src": "images/squ.jpg",
      "width": "5"
    }
  })]), _c('span', {
    staticClass: "spacea"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Bison")])]), _vm._v(" "), _c('p', {
    staticClass: "bulllist"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "src": "images/squ.jpg"
    }
  }), _c('span', {
    staticClass: "hide"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "4",
      "src": "images/squ.jpg",
      "width": "5"
    }
  })]), _c('span', {
    staticClass: "spacea"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Chicken")])]), _vm._v(" "), _c('p', {
    staticClass: "bulllist"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "src": "images/squ.jpg"
    }
  }), _c('span', {
    staticClass: "hide"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "4",
      "src": "images/squ.jpg",
      "width": "5"
    }
  })]), _c('span', {
    staticClass: "spacea"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Duck")])]), _vm._v(" "), _c('p', {
    staticClass: "bulllist"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "src": "images/squ.jpg"
    }
  }), _c('span', {
    staticClass: "hide"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "4",
      "src": "images/squ.jpg",
      "width": "5"
    }
  })]), _c('span', {
    staticClass: "spacea"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Lamb")])]), _vm._v(" "), _c('p', {
    staticClass: "bulllist"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "src": "images/squ.jpg"
    }
  }), _c('span', {
    staticClass: "hide"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "4",
      "src": "images/squ.jpg",
      "width": "5"
    }
  })]), _c('span', {
    staticClass: "spacea"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Organ meats")])]), _vm._v(" "), _c('p', {
    staticClass: "bulllist"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "src": "images/squ.jpg"
    }
  }), _c('span', {
    staticClass: "hide"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "4",
      "src": "images/squ.jpg",
      "width": "5"
    }
  })]), _c('span', {
    staticClass: "spacea"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Pork")])]), _vm._v(" "), _c('p', {
    staticClass: "bulllist"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "src": "images/squ.jpg"
    }
  }), _c('span', {
    staticClass: "hide"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "4",
      "src": "images/squ.jpg",
      "width": "5"
    }
  })]), _c('span', {
    staticClass: "spacea"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Quail")])]), _vm._v(" "), _c('p', {
    staticClass: "bulllist"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "src": "images/squ.jpg"
    }
  }), _c('span', {
    staticClass: "hide"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "4",
      "src": "images/squ.jpg",
      "width": "5"
    }
  })]), _c('span', {
    staticClass: "spacea"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Turkey")])]), _vm._v(" "), _c('p', {
    staticClass: "bulllist"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "src": "images/squ.jpg"
    }
  }), _c('span', {
    staticClass: "hide"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "4",
      "src": "images/squ.jpg",
      "width": "5"
    }
  })]), _c('span', {
    staticClass: "spacea"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Venison")])]), _vm._v(" "), _c('p', {
    staticClass: "ch-sec"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_12",
      "title": "12"
    }
  }, [_vm._v("Fish and Seafood")])]), _vm._v(" "), _c('p', {
    staticClass: "normal-bs"
  }, [_vm._v("Choose wild seafood over farmed, except in the case of shellfish, such as mussels and oysters. To avoid excess mercury exposure, choose fish at the bottom of the food chain and only occasionally eat predators such as shark and tuna. Here are the more common seafood options in the Paleo diet:")]), _vm._v(" "), _c('p', {
    staticClass: "bulllist"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "src": "images/squ.jpg"
    }
  }), _c('span', {
    staticClass: "hide"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "4",
      "src": "images/squ.jpg",
      "width": "5"
    }
  })]), _c('span', {
    staticClass: "spacea"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Abalone")])]), _vm._v(" "), _c('p', {
    staticClass: "bulllist"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "src": "images/squ.jpg"
    }
  }), _c('span', {
    staticClass: "hide"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "4",
      "src": "images/squ.jpg",
      "width": "5"
    }
  })]), _c('span', {
    staticClass: "spacea"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Anchovies")])]), _vm._v(" "), _c('p', {
    staticClass: "bulllist"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "src": "images/squ.jpg"
    }
  }), _c('span', {
    staticClass: "hide"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "4",
      "src": "images/squ.jpg",
      "width": "5"
    }
  })]), _c('span', {
    staticClass: "spacea"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Clams")])]), _vm._v(" "), _c('p', {
    staticClass: "bulllist"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "src": "images/squ.jpg"
    }
  }), _c('span', {
    staticClass: "hide"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "4",
      "src": "images/squ.jpg",
      "width": "5"
    }
  })]), _c('span', {
    staticClass: "spacea"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Cod")])]), _vm._v(" "), _c('p', {
    staticClass: "bulllist"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "src": "images/squ.jpg"
    }
  }), _c('span', {
    staticClass: "hide"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "4",
      "src": "images/squ.jpg",
      "width": "5"
    }
  })]), _c('span', {
    staticClass: "spacea"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Halibut")])]), _vm._v(" "), _c('p', {
    staticClass: "bulllist"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "src": "images/squ.jpg"
    }
  }), _c('span', {
    staticClass: "hide"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "4",
      "src": "images/squ.jpg",
      "width": "5"
    }
  })]), _c('span', {
    staticClass: "spacea"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Mussels")])]), _vm._v(" "), _c('p', {
    staticClass: "bulllist"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "src": "images/squ.jpg"
    }
  }), _c('span', {
    staticClass: "hide"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "4",
      "src": "images/squ.jpg",
      "width": "5"
    }
  })]), _c('span', {
    staticClass: "spacea"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Oysters")])]), _vm._v(" "), _c('p', {
    staticClass: "bulllist"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "src": "images/squ.jpg"
    }
  }), _c('span', {
    staticClass: "hide"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "4",
      "src": "images/squ.jpg",
      "width": "5"
    }
  })]), _c('span', {
    staticClass: "spacea"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Salmon")])]), _vm._v(" "), _c('p', {
    staticClass: "bulllist"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "src": "images/squ.jpg"
    }
  }), _c('span', {
    staticClass: "hide"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "4",
      "src": "images/squ.jpg",
      "width": "5"
    }
  })]), _c('span', {
    staticClass: "spacea"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Sardines")])]), _vm._v(" "), _c('p', {
    staticClass: "bulllist"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "src": "images/squ.jpg"
    }
  }), _c('span', {
    staticClass: "hide"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "4",
      "src": "images/squ.jpg",
      "width": "5"
    }
  })]), _c('span', {
    staticClass: "spacea"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Scallops")])]), _vm._v(" "), _c('p', {
    staticClass: "bulllist"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "src": "images/squ.jpg"
    }
  }), _c('span', {
    staticClass: "hide"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "4",
      "src": "images/squ.jpg",
      "width": "5"
    }
  })]), _c('span', {
    staticClass: "spacea"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Sea Bass")])]), _vm._v(" "), _c('p', {
    staticClass: "bulllist"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "src": "images/squ.jpg"
    }
  }), _c('span', {
    staticClass: "hide"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "4",
      "src": "images/squ.jpg",
      "width": "5"
    }
  })]), _c('span', {
    staticClass: "spacea"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Shrimp")])]), _vm._v(" "), _c('p', {
    staticClass: "bulllist"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "src": "images/squ.jpg"
    }
  }), _c('span', {
    staticClass: "hide"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "4",
      "src": "images/squ.jpg",
      "width": "5"
    }
  })]), _c('span', {
    staticClass: "spacea"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Snapper")])]), _vm._v(" "), _c('p', {
    staticClass: "bulllist"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "src": "images/squ.jpg"
    }
  }), _c('span', {
    staticClass: "hide"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "4",
      "src": "images/squ.jpg",
      "width": "5"
    }
  })]), _c('span', {
    staticClass: "spacea"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Trout")])]), _vm._v(" "), _c('p', {
    staticClass: "ch-sec"
  }, [_vm._v("Vegetables")]), _vm._v(" "), _c('p', {
    staticClass: "normal-bs"
  }, [_vm._v("The healthiest approach to Paleo includes loads of non-starchy vegetables. Choose locally grown, organic produce whenever possible and avoid canned vegetables, which are bereft of nutritional value. (I make an exception for canned tomatoes, technically a fruit.) Here are the more common vegetable options in the Paleo diet:")]), _vm._v(" "), _c('p', {
    staticClass: "bulllist"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "src": "images/squ.jpg"
    }
  }), _c('span', {
    staticClass: "hide"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "4",
      "src": "images/squ.jpg",
      "width": "5"
    }
  })]), _c('span', {
    staticClass: "spacea"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Acorn squash")])]), _vm._v(" "), _c('p', {
    staticClass: "bulllist"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "src": "images/squ.jpg"
    }
  }), _c('span', {
    staticClass: "hide"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "4",
      "src": "images/squ.jpg",
      "width": "5"
    }
  })]), _c('span', {
    staticClass: "spacea"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Artichokes")])]), _vm._v(" "), _c('p', {
    staticClass: "bulllist"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "src": "images/squ.jpg"
    }
  }), _c('span', {
    staticClass: "hide"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "4",
      "src": "images/squ.jpg",
      "width": "5"
    }
  })]), _c('span', {
    staticClass: "spacea"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Asparagus")])]), _vm._v(" "), _c('p', {
    staticClass: "bulllist"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "src": "images/squ.jpg"
    }
  }), _c('span', {
    staticClass: "hide"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "4",
      "src": "images/squ.jpg",
      "width": "5"
    }
  })]), _c('span', {
    staticClass: "spacea"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Bell peppers")])]), _vm._v(" "), _c('p', {
    staticClass: "bulllist"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "src": "images/squ.jpg"
    }
  }), _c('span', {
    staticClass: "hide"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "4",
      "src": "images/squ.jpg",
      "width": "5"
    }
  })]), _c('span', {
    staticClass: "spacea"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Broccoli")])]), _vm._v(" "), _c('p', {
    staticClass: "bulllist"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "src": "images/squ.jpg"
    }
  }), _c('span', {
    staticClass: "hide"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "4",
      "src": "images/squ.jpg",
      "width": "5"
    }
  })]), _c('span', {
    staticClass: "spacea"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Brussels sprouts")])]), _vm._v(" "), _c('p', {
    staticClass: "bulllist"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "src": "images/squ.jpg"
    }
  }), _c('span', {
    staticClass: "hide"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "4",
      "src": "images/squ.jpg",
      "width": "5"
    }
  })]), _c('span', {
    staticClass: "spacea"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Butternut squash")])]), _vm._v(" "), _c('p', {
    staticClass: "bulllist"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "src": "images/squ.jpg"
    }
  }), _c('span', {
    staticClass: "hide"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "4",
      "src": "images/squ.jpg",
      "width": "5"
    }
  })]), _c('span', {
    staticClass: "spacea"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Cabbage")])]), _vm._v(" "), _c('p', {
    staticClass: "bulllist"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "src": "images/squ.jpg"
    }
  }), _c('span', {
    staticClass: "hide"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "4",
      "src": "images/squ.jpg",
      "width": "5"
    }
  })]), _c('span', {
    staticClass: "spacea"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Cauliflower")])]), _vm._v(" "), _c('p', {
    staticClass: "bulllist"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "src": "images/squ.jpg"
    }
  }), _c('span', {
    staticClass: "hide"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "4",
      "src": "images/squ.jpg",
      "width": "5"
    }
  })]), _c('span', {
    staticClass: "spacea"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Collard greens")])]), _vm._v(" "), _c('p', {
    staticClass: "bulllist"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "src": "images/squ.jpg"
    }
  }), _c('span', {
    staticClass: "hide"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "4",
      "src": "images/squ.jpg",
      "width": "5"
    }
  })]), _c('span', {
    staticClass: "spacea"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Cucumbers")])]), _vm._v(" "), _c('p', {
    staticClass: "bulllist"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "src": "images/squ.jpg"
    }
  }), _c('span', {
    staticClass: "hide"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "4",
      "src": "images/squ.jpg",
      "width": "5"
    }
  })]), _c('span', {
    staticClass: "spacea"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Eggplants")])]), _vm._v(" "), _c('p', {
    staticClass: "bulllist"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "src": "images/squ.jpg"
    }
  }), _c('span', {
    staticClass: "hide"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "4",
      "src": "images/squ.jpg",
      "width": "5"
    }
  })]), _c('span', {
    staticClass: "spacea"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Endive")])]), _vm._v(" "), _c('p', {
    staticClass: "bulllist"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "src": "images/squ.jpg"
    }
  }), _c('span', {
    staticClass: "hide"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "4",
      "src": "images/squ.jpg",
      "width": "5"
    }
  })]), _c('span', {
    staticClass: "spacea"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Fennel")])]), _vm._v(" "), _c('p', {
    staticClass: "bulllist"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_13",
      "title": "13"
    }
  }, [_c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "src": "images/squ.jpg"
    }
  }), _c('span', {
    staticClass: "hide"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "4",
      "src": "images/squ.jpg",
      "width": "5"
    }
  })]), _c('span', {
    staticClass: "spacea"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Green beans")])])]), _vm._v(" "), _c('p', {
    staticClass: "bulllist"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "src": "images/squ.jpg"
    }
  }), _c('span', {
    staticClass: "hide"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "4",
      "src": "images/squ.jpg",
      "width": "5"
    }
  })]), _c('span', {
    staticClass: "spacea"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Kohlrabi")])]), _vm._v(" "), _c('p', {
    staticClass: "bulllist"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "src": "images/squ.jpg"
    }
  }), _c('span', {
    staticClass: "hide"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "4",
      "src": "images/squ.jpg",
      "width": "5"
    }
  })]), _c('span', {
    staticClass: "spacea"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Leeks")])]), _vm._v(" "), _c('p', {
    staticClass: "bulllist"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "src": "images/squ.jpg"
    }
  }), _c('span', {
    staticClass: "hide"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "4",
      "src": "images/squ.jpg",
      "width": "5"
    }
  })]), _c('span', {
    staticClass: "spacea"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Mushrooms")])]), _vm._v(" "), _c('p', {
    staticClass: "bulllist"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "src": "images/squ.jpg"
    }
  }), _c('span', {
    staticClass: "hide"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "4",
      "src": "images/squ.jpg",
      "width": "5"
    }
  })]), _c('span', {
    staticClass: "spacea"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Onions")])]), _vm._v(" "), _c('p', {
    staticClass: "bulllist"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "src": "images/squ.jpg"
    }
  }), _c('span', {
    staticClass: "hide"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "4",
      "src": "images/squ.jpg",
      "width": "5"
    }
  })]), _c('span', {
    staticClass: "spacea"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Peas")])]), _vm._v(" "), _c('p', {
    staticClass: "bulllist"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "src": "images/squ.jpg"
    }
  }), _c('span', {
    staticClass: "hide"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "4",
      "src": "images/squ.jpg",
      "width": "5"
    }
  })]), _c('span', {
    staticClass: "spacea"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Pumpkin")])]), _vm._v(" "), _c('p', {
    staticClass: "bulllist"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "src": "images/squ.jpg"
    }
  }), _c('span', {
    staticClass: "hide"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "4",
      "src": "images/squ.jpg",
      "width": "5"
    }
  })]), _c('span', {
    staticClass: "spacea"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Radicchio")])]), _vm._v(" "), _c('p', {
    staticClass: "bulllist"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "src": "images/squ.jpg"
    }
  }), _c('span', {
    staticClass: "hide"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "4",
      "src": "images/squ.jpg",
      "width": "5"
    }
  })]), _c('span', {
    staticClass: "spacea"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Radishes")])]), _vm._v(" "), _c('p', {
    staticClass: "bulllist"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "src": "images/squ.jpg"
    }
  }), _c('span', {
    staticClass: "hide"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "4",
      "src": "images/squ.jpg",
      "width": "5"
    }
  })]), _c('span', {
    staticClass: "spacea"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Snow peas")])]), _vm._v(" "), _c('p', {
    staticClass: "bulllist"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "src": "images/squ.jpg"
    }
  }), _c('span', {
    staticClass: "hide"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "4",
      "src": "images/squ.jpg",
      "width": "5"
    }
  })]), _c('span', {
    staticClass: "spacea"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Spinach")])]), _vm._v(" "), _c('p', {
    staticClass: "bulllist"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "src": "images/squ.jpg"
    }
  }), _c('span', {
    staticClass: "hide"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "4",
      "src": "images/squ.jpg",
      "width": "5"
    }
  })]), _c('span', {
    staticClass: "spacea"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Swiss chard")])]), _vm._v(" "), _c('p', {
    staticClass: "bulllist"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "src": "images/squ.jpg"
    }
  }), _c('span', {
    staticClass: "hide"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "4",
      "src": "images/squ.jpg",
      "width": "5"
    }
  })]), _c('span', {
    staticClass: "spacea"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Watercress")])]), _vm._v(" "), _c('p', {
    staticClass: "bulllist"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "src": "images/squ.jpg"
    }
  }), _c('span', {
    staticClass: "hide"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "4",
      "src": "images/squ.jpg",
      "width": "5"
    }
  })]), _c('span', {
    staticClass: "spacea"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Zucchini")])]), _vm._v(" "), _c('p', {
    staticClass: "normal-ts5"
  }, [_vm._v("Root vegetables, often called “starchy tubers,” are a great source of carbohydrates in an otherwise low-carb diet. Potatoes are a gray area in Paleo because of their high glycemic index and the saponins in potato skins. However, many Paleo diet proponents recommend them because they provide resistant starch when cooked and cooled and are a good source of energy. I have included them sparingly in this book, knowing that some people choose to avoid them. Use sweet potatoes in their place if you wish.")]), _vm._v(" "), _c('p', {
    staticClass: "normal-tbs"
  }, [_vm._v("Here are some of the more common varieties of root vegetables in the Paleo diet:")]), _vm._v(" "), _c('p', {
    staticClass: "bulllist"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "src": "images/squ.jpg"
    }
  }), _c('span', {
    staticClass: "hide"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "4",
      "src": "images/squ.jpg",
      "width": "5"
    }
  })]), _c('span', {
    staticClass: "spacea"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Carrots")])]), _vm._v(" "), _c('p', {
    staticClass: "bulllist"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "src": "images/squ.jpg"
    }
  }), _c('span', {
    staticClass: "hide"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "4",
      "src": "images/squ.jpg",
      "width": "5"
    }
  })]), _c('span', {
    staticClass: "spacea"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Potatoes")])]), _vm._v(" "), _c('p', {
    staticClass: "bulllist"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "src": "images/squ.jpg"
    }
  }), _c('span', {
    staticClass: "hide"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "4",
      "src": "images/squ.jpg",
      "width": "5"
    }
  })]), _c('span', {
    staticClass: "spacea"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Rutabagas")])]), _vm._v(" "), _c('p', {
    staticClass: "bulllist"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "src": "images/squ.jpg"
    }
  }), _c('span', {
    staticClass: "hide"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "4",
      "src": "images/squ.jpg",
      "width": "5"
    }
  })]), _c('span', {
    staticClass: "spacea"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Sweet potatoes")])]), _vm._v(" "), _c('p', {
    staticClass: "bulllist"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "src": "images/squ.jpg"
    }
  }), _c('span', {
    staticClass: "hide"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "4",
      "src": "images/squ.jpg",
      "width": "5"
    }
  })]), _c('span', {
    staticClass: "spacea"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Turnips")])]), _vm._v(" "), _c('p', {
    staticClass: "ch-sec"
  }, [_vm._v("Fruit")]), _vm._v(" "), _c('p', {
    staticClass: "normal-bs"
  }, [_vm._v("Fruit provides a delicious accent to the Paleo diet but ideally should be locally grown, in season, and consumed in moderation, especially for people who are trying to lose weight. Avocado and tomato are typically considered vegetables and do not contain the same amount of fructose and glucose present in sweet fruits. Here are the more common fruit options in the Paleo diet:")]), _vm._v(" "), _c('p', {
    staticClass: "bulllist"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "src": "images/squ.jpg"
    }
  }), _c('span', {
    staticClass: "hide"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "4",
      "src": "images/squ.jpg",
      "width": "5"
    }
  })]), _c('span', {
    staticClass: "spacea"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Apples")])]), _vm._v(" "), _c('p', {
    staticClass: "bulllist"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "src": "images/squ.jpg"
    }
  }), _c('span', {
    staticClass: "hide"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "4",
      "src": "images/squ.jpg",
      "width": "5"
    }
  })]), _c('span', {
    staticClass: "spacea"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Avocados")])]), _vm._v(" "), _c('p', {
    staticClass: "bulllist"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "src": "images/squ.jpg"
    }
  }), _c('span', {
    staticClass: "hide"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "4",
      "src": "images/squ.jpg",
      "width": "5"
    }
  })]), _c('span', {
    staticClass: "spacea"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Blackberries")])]), _vm._v(" "), _c('p', {
    staticClass: "bulllist"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "src": "images/squ.jpg"
    }
  }), _c('span', {
    staticClass: "hide"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "4",
      "src": "images/squ.jpg",
      "width": "5"
    }
  })]), _c('span', {
    staticClass: "spacea"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Blueberries")])]), _vm._v(" "), _c('p', {
    staticClass: "bulllist"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "src": "images/squ.jpg"
    }
  }), _c('span', {
    staticClass: "hide"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "4",
      "src": "images/squ.jpg",
      "width": "5"
    }
  })]), _c('span', {
    staticClass: "spacea"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Cantaloupe")])]), _vm._v(" "), _c('p', {
    staticClass: "bulllist"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "src": "images/squ.jpg"
    }
  }), _c('span', {
    staticClass: "hide"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "4",
      "src": "images/squ.jpg",
      "width": "5"
    }
  })]), _c('span', {
    staticClass: "spacea"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Citrus fruits")])]), _vm._v(" "), _c('p', {
    staticClass: "bulllist"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "src": "images/squ.jpg"
    }
  }), _c('span', {
    staticClass: "hide"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "4",
      "src": "images/squ.jpg",
      "width": "5"
    }
  })]), _c('span', {
    staticClass: "spacea"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Figs")])]), _vm._v(" "), _c('p', {
    staticClass: "bulllist"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_14",
      "title": "14"
    }
  }, [_c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "src": "images/squ.jpg"
    }
  }), _c('span', {
    staticClass: "hide"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "4",
      "src": "images/squ.jpg",
      "width": "5"
    }
  })]), _c('span', {
    staticClass: "spacea"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Grapes")])])]), _vm._v(" "), _c('p', {
    staticClass: "bulllist"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "src": "images/squ.jpg"
    }
  }), _c('span', {
    staticClass: "hide"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "4",
      "src": "images/squ.jpg",
      "width": "5"
    }
  })]), _c('span', {
    staticClass: "spacea"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Mango")])]), _vm._v(" "), _c('p', {
    staticClass: "bulllist"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "src": "images/squ.jpg"
    }
  }), _c('span', {
    staticClass: "hide"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "4",
      "src": "images/squ.jpg",
      "width": "5"
    }
  })]), _c('span', {
    staticClass: "spacea"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Nectarines")])]), _vm._v(" "), _c('p', {
    staticClass: "bulllist"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "src": "images/squ.jpg"
    }
  }), _c('span', {
    staticClass: "hide"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "4",
      "src": "images/squ.jpg",
      "width": "5"
    }
  })]), _c('span', {
    staticClass: "spacea"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Peaches")])]), _vm._v(" "), _c('p', {
    staticClass: "bulllist"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "src": "images/squ.jpg"
    }
  }), _c('span', {
    staticClass: "hide"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "4",
      "src": "images/squ.jpg",
      "width": "5"
    }
  })]), _c('span', {
    staticClass: "spacea"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Pears")])]), _vm._v(" "), _c('p', {
    staticClass: "bulllist"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "src": "images/squ.jpg"
    }
  }), _c('span', {
    staticClass: "hide"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "4",
      "src": "images/squ.jpg",
      "width": "5"
    }
  })]), _c('span', {
    staticClass: "spacea"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Plums")])]), _vm._v(" "), _c('p', {
    staticClass: "bulllist"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "src": "images/squ.jpg"
    }
  }), _c('span', {
    staticClass: "hide"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "4",
      "src": "images/squ.jpg",
      "width": "5"
    }
  })]), _c('span', {
    staticClass: "spacea"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Raspberries")])]), _vm._v(" "), _c('p', {
    staticClass: "bulllist"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "src": "images/squ.jpg"
    }
  }), _c('span', {
    staticClass: "hide"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "4",
      "src": "images/squ.jpg",
      "width": "5"
    }
  })]), _c('span', {
    staticClass: "spacea"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Rhubarb")])]), _vm._v(" "), _c('p', {
    staticClass: "bulllist"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "src": "images/squ.jpg"
    }
  }), _c('span', {
    staticClass: "hide"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "4",
      "src": "images/squ.jpg",
      "width": "5"
    }
  })]), _c('span', {
    staticClass: "spacea"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Strawberries")])]), _vm._v(" "), _c('p', {
    staticClass: "bulllist"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "src": "images/squ.jpg"
    }
  }), _c('span', {
    staticClass: "hide"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "4",
      "src": "images/squ.jpg",
      "width": "5"
    }
  })]), _c('span', {
    staticClass: "spacea"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Tomatoes")])]), _vm._v(" "), _c('p', {
    staticClass: "bulllist"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "src": "images/squ.jpg"
    }
  }), _c('span', {
    staticClass: "hide"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "4",
      "src": "images/squ.jpg",
      "width": "5"
    }
  })]), _c('span', {
    staticClass: "spacea"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Watermelon")])]), _vm._v(" "), _c('p', {
    staticClass: "bulllist"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "src": "images/squ.jpg"
    }
  }), _c('span', {
    staticClass: "hide"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "4",
      "src": "images/squ.jpg",
      "width": "5"
    }
  })]), _c('span', {
    staticClass: "spacea"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Root Vegetables")])]), _vm._v(" "), _c('p', {
    staticClass: "ch-sec"
  }, [_vm._v("Nuts and Seeds")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("Nuts and seeds are great for sprinkling on salads, snacking, and using in Paleo baked goods. To improve their digestibility, soak nuts and seeds in fresh water overnight, rinse and drain thoroughly, and add to the desired recipe. To make them dry and crisp, spread the soaked nuts on a tray and place in a dehydrator or warmed oven until crisp. Drying times vary significantly depending on the type of nut.")]), _vm._v(" "), _c('p', {
    staticClass: "normal-ts"
  }, [_vm._v("Peanuts are not a nut but a legume and are thus not part of the Paleo diet. While they do have a similar macronutrient profile to tree nuts, such as almonds, they may cause digestive discomfort and are not included in this book.")]), _vm._v(" "), _c('p', {
    staticClass: "normal-tbs"
  }, [_vm._v("Here are some of the more common varieties of nuts in the Paleo diet:")]), _vm._v(" "), _c('p', {
    staticClass: "bulllist"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "src": "images/squ.jpg"
    }
  }), _c('span', {
    staticClass: "hide"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "4",
      "src": "images/squ.jpg",
      "width": "5"
    }
  })]), _c('span', {
    staticClass: "spacea"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Almonds")])]), _vm._v(" "), _c('p', {
    staticClass: "bulllist"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "src": "images/squ.jpg"
    }
  }), _c('span', {
    staticClass: "hide"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "4",
      "src": "images/squ.jpg",
      "width": "5"
    }
  })]), _c('span', {
    staticClass: "spacea"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Brazil nuts")])]), _vm._v(" "), _c('p', {
    staticClass: "bulllist"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "src": "images/squ.jpg"
    }
  }), _c('span', {
    staticClass: "hide"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "4",
      "src": "images/squ.jpg",
      "width": "5"
    }
  })]), _c('span', {
    staticClass: "spacea"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Cashews")])]), _vm._v(" "), _c('p', {
    staticClass: "bulllist"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "src": "images/squ.jpg"
    }
  }), _c('span', {
    staticClass: "hide"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "4",
      "src": "images/squ.jpg",
      "width": "5"
    }
  })]), _c('span', {
    staticClass: "spacea"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Macadamia nuts")])]), _vm._v(" "), _c('p', {
    staticClass: "bulllist"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "src": "images/squ.jpg"
    }
  }), _c('span', {
    staticClass: "hide"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "4",
      "src": "images/squ.jpg",
      "width": "5"
    }
  })]), _c('span', {
    staticClass: "spacea"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Pistachios")])]), _vm._v(" "), _c('p', {
    staticClass: "bulllist"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "src": "images/squ.jpg"
    }
  }), _c('span', {
    staticClass: "hide"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "4",
      "src": "images/squ.jpg",
      "width": "5"
    }
  })]), _c('span', {
    staticClass: "spacea"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Sesame seeds")])]), _vm._v(" "), _c('p', {
    staticClass: "bulllist"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "src": "images/squ.jpg"
    }
  }), _c('span', {
    staticClass: "hide"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "4",
      "src": "images/squ.jpg",
      "width": "5"
    }
  })]), _c('span', {
    staticClass: "spacea"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Sunflower seeds")])]), _vm._v(" "), _c('p', {
    staticClass: "bulllist"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "src": "images/squ.jpg"
    }
  }), _c('span', {
    staticClass: "hide"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "4",
      "src": "images/squ.jpg",
      "width": "5"
    }
  })]), _c('span', {
    staticClass: "spacea"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Walnuts")])]), _vm._v(" "), _c('p', {
    staticClass: "ch-sec"
  }, [_vm._v("Healthy Fats")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("I prefer to use refined coconut oil in high-heat cooking because it stands up well to the heat and does not impart a coconut flavor to the food. Sometimes that is desirable, such as with the "), _c('span', {
    attrs: {
      "href": "#/text/Recp35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Coconut-Crusted Plantain Tacos")]), _vm._v(" (page 57), but I don’t want all of my food to taste like coconut. I only use extra-virgin olive oil in raw preparations, such as salad dressings, and sometimes in low to moderate heat cooking with the cast iron skillet.")]), _vm._v(" "), _c('p', {
    staticClass: "normal-tbs"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_15",
      "title": "15"
    }
  }, [_vm._v("Avocado and macadamia oils have a more neutral flavor than olive oil and are especially useful in making mayonnaise and aioli. Ghee is clarified butter and has a deliciously buttery aroma and flavor. However, some people are especially sensitive to dairy, so I provide alternatives whenever I call for it in a recipe.")])]), _vm._v(" "), _c('p', {
    staticClass: "bulllist"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "src": "images/squ.jpg"
    }
  }), _c('span', {
    staticClass: "hide"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "4",
      "src": "images/squ.jpg",
      "width": "5"
    }
  })]), _c('span', {
    staticClass: "spacea"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Avocado oil")])]), _vm._v(" "), _c('p', {
    staticClass: "bulllist"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "src": "images/squ.jpg"
    }
  }), _c('span', {
    staticClass: "hide"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "4",
      "src": "images/squ.jpg",
      "width": "5"
    }
  })]), _c('span', {
    staticClass: "spacea"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Coconut oil")])]), _vm._v(" "), _c('p', {
    staticClass: "bulllist"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "src": "images/squ.jpg"
    }
  }), _c('span', {
    staticClass: "hide"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "4",
      "src": "images/squ.jpg",
      "width": "5"
    }
  })]), _c('span', {
    staticClass: "spacea"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Ghee")])]), _vm._v(" "), _c('p', {
    staticClass: "bulllist"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "src": "images/squ.jpg"
    }
  }), _c('span', {
    staticClass: "hide"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "4",
      "src": "images/squ.jpg",
      "width": "5"
    }
  })]), _c('span', {
    staticClass: "spacea"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Macadamia oil")])]), _vm._v(" "), _c('p', {
    staticClass: "bulllist"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "src": "images/squ.jpg"
    }
  }), _c('span', {
    staticClass: "hide"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "4",
      "src": "images/squ.jpg",
      "width": "5"
    }
  })]), _c('span', {
    staticClass: "spacea"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Extra-virgin olive oil")])]), _vm._v(" "), _c('p', {
    staticClass: "ch-sec"
  }, [_vm._v("Fermented Foods")]), _vm._v(" "), _c('p', {
    staticClass: "normal-bs"
  }, [_vm._v("Fermentation occurs in nature and has been part of the human diet since the beginning. Fermented foods are present in most cultures and offer a friendly boost to the gut microbiome. Make your own ferments or purchase them from the store. Soybeans are a legume and thus not technically Paleo. However, fermenting soy improves its digestibility. I include it sparingly in this book. If you prefer, use coconut aminos instead of soy sauce when called for in a recipe. Here are just a few of the most common fermented foods:")]), _vm._v(" "), _c('p', {
    staticClass: "bulllist"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "src": "images/squ.jpg"
    }
  }), _c('span', {
    staticClass: "hide"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "4",
      "src": "images/squ.jpg",
      "width": "5"
    }
  })]), _c('span', {
    staticClass: "spacea"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Kimchi")])]), _vm._v(" "), _c('p', {
    staticClass: "bulllist"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "src": "images/squ.jpg"
    }
  }), _c('span', {
    staticClass: "hide"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "4",
      "src": "images/squ.jpg",
      "width": "5"
    }
  })]), _c('span', {
    staticClass: "spacea"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Kombucha")])]), _vm._v(" "), _c('p', {
    staticClass: "bulllist"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "src": "images/squ.jpg"
    }
  }), _c('span', {
    staticClass: "hide"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "4",
      "src": "images/squ.jpg",
      "width": "5"
    }
  })]), _c('span', {
    staticClass: "spacea"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Miso")])]), _vm._v(" "), _c('p', {
    staticClass: "bulllist"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "src": "images/squ.jpg"
    }
  }), _c('span', {
    staticClass: "hide"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "4",
      "src": "images/squ.jpg",
      "width": "5"
    }
  })]), _c('span', {
    staticClass: "spacea"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Pickles")])]), _vm._v(" "), _c('p', {
    staticClass: "bulllist"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "src": "images/squ.jpg"
    }
  }), _c('span', {
    staticClass: "hide"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "4",
      "src": "images/squ.jpg",
      "width": "5"
    }
  })]), _c('span', {
    staticClass: "spacea"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Preserved lemons")])]), _vm._v(" "), _c('p', {
    staticClass: "bulllist"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "src": "images/squ.jpg"
    }
  }), _c('span', {
    staticClass: "hide"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "4",
      "src": "images/squ.jpg",
      "width": "5"
    }
  })]), _c('span', {
    staticClass: "spacea"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Sauerkraut")])]), _vm._v(" "), _c('p', {
    staticClass: "bulllist"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "src": "images/squ.jpg"
    }
  }), _c('span', {
    staticClass: "hide"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "4",
      "src": "images/squ.jpg",
      "width": "5"
    }
  })]), _c('span', {
    staticClass: "spacea"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Soy sauce")])]), _vm._v(" "), _c('p', {
    staticClass: "bulllist"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "src": "images/squ.jpg"
    }
  }), _c('span', {
    staticClass: "hide"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "4",
      "src": "images/squ.jpg",
      "width": "5"
    }
  })]), _c('span', {
    staticClass: "spacea"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Yogurt")])]), _vm._v(" "), _c('p', {
    staticClass: "ch-sub"
  }, [_c('b', [_vm._v("What Not to Eat")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("Noticeably absent from the menu are grains, legumes, dairy, refined sugar, and processed foods.")]), _vm._v(" "), _c('p', {
    staticClass: "ch-sec"
  }, [_vm._v("Grains and Legumes")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("Grains, particularly wheat and corn, comprise the vast majority of the Standard American Diet, which isn’t surprising since grains were placed at the foundation of the food pyramid by the USDA. Processed grains in the form of wheat bread, bagels, and cereals took the place of healthful fats during the last half of the twentieth century, when the low-fat diet dogma took hold. Unfortunately, overconsumption of grains, namely wheat, and added sugars has had devastating effects on public health. They elevate blood sugar and insulin, contributing to diabetes, heart disease, and a host of other chronic and degenerative diseases, not the least of which is obesity. Legumes also elevate blood sugar, though not as dramatically as grains.")]), _vm._v(" "), _c('p', {
    staticClass: "normal-ts"
  }, [_vm._v("Both grains and legumes contain naturally occurring chemicals that make them difficult to digest and contribute to a permeable gut membrane, which may trigger autoimmune disorders.")]), _vm._v(" "), _c('p', {
    staticClass: "ch-sec"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_16",
      "title": "16"
    }
  }, [_vm._v("Dairy")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("Cow’s milk contains proteins and sugars that many adults find difficult to digest and are causative of allergic reactions. However, some Paleo proponents suggest after an elimination period that full-fat dairy products should be re-introduced to determine tolerance. The first to try is ghee, which is pure butterfat clarified to remove lactose, casein, or whey. Other options include heavy cream, butter, full-fat yogurt, and some cheeses.")]), _vm._v(" "), _c('p', {
    staticClass: "ch-sec"
  }, [_vm._v("Refined Sugar")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("Refined sugar in all its forms (white sugar, brown sugar, and high-fructose corn syrup) is not on the Paleo table. It has destructive effects on blood sugar levels, insulin production, weight control, inflammation, and mental health, not to mention its addictive nature. Many people in the Paleo community consider honey, maple syrup, and coconut palm sugar acceptable forms of sugar. I have included a chapter of desserts featuring these sweeteners in modest amounts, but I think it’s important to remember that hunter gatherers don’t eat salted caramel cupcakes made with almond flour and maple syrup and dusted with fleur de sel.")]), _vm._v(" "), _c('p', {
    staticClass: "ch-sec"
  }, [_vm._v("Processed Foods")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("Processed foods—the foods that comprise the majority of the average grocery store—are not on the Paleo menu. Processed food is any food that has been deconstructed, pulverized, concentrated, and reassembled into something completely unlike the original food in nutritional value. Michael Pollan calls these “edible food like substances.”")]), _vm._v(" "), _c('p', {
    staticClass: "ch-sub"
  }, [_c('b', [_vm._v("Serving Sizes")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("In this book I offer a range of serving sizes. Clearly, a middle-aged man with a sedentary occupation consumes far less than a young woman who cycles to work and spends her weekends competing in triathlons. To gauge the correct serving size for you, glance at the ingredients and compare them to the portions you typically eat. When a recipe is labeled “Serves 2 to 4,” it is intended to feed two moderately active adults and two children.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0003cd45","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/Chapter2.vue
// module id = 78
// module chunks = 0